import { useQueryClient } from '@tanstack/react-query';

import { useFormMutation } from 'mutations/useFormMutation';

export function useMutateRelatorioAnalitico() {
    const { mutate, isLoading } = useFormMutation();
    const queryClient = useQueryClient();

    /**
     * Inicia o download o relatório analítico da apuração.
     */
    const handlerRelatorioAnalitico = (idApuracao: number) => {
        mutate(
            {
                url: `/financeiro/apuracao/gerarelatorioreembolso?idApuracao=${idApuracao}`,
            },
            {
                onSuccess: () => queryClient.invalidateQueries(['queryApuracoes']),
            },
        );
    };

    return { handlerRelatorioAnalitico, isLoading };
}
